// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../redux/modules/actions';
import ResponseLeads          from './ResponseLeads';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchScoreCardDataIfNeeded:   actions.fetchScoreCardDataIfNeeded,
        fetchStatsTableDataIfNeeded:  actions.fetchStatsTableDataIfNeeded,
        fetchStatsGraphDataIfNeeded:  actions.fetchStatsGraphDataIfNeeded,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResponseLeads);



// WEBPACK FOOTER //
// ./src/app/views/partner/responseLeads/index.js